import {WalkthroughDefinition} from '../types';

export const TALENT_POOL_TOUR_TARGETS = {
  title: 'talentPool.title',
  stats: 'talentPool.stats',
  filters: 'talentPool.filters',
  table: 'talentPool.table',
  rowActionMatch: 'talentPool.rowAction.match',
  rowActionView: 'talentPool.rowAction.view',
  pagination: 'talentPool.pagination',
} as const;

export const companyTalentPoolWalkthrough: WalkthroughDefinition = {
  id: 'companyTalentPool',
  version: 2,
  steps: [
    {
      target: TALENT_POOL_TOUR_TARGETS.title,
      titleKey: 'walkthrough.talentPool.welcome.title',
      bodyKey: 'walkthrough.talentPool.welcome.body',
      placement: 'bottom-start',
    },
    {
      target: TALENT_POOL_TOUR_TARGETS.stats,
      titleKey: 'walkthrough.talentPool.stats.title',
      bodyKey: 'walkthrough.talentPool.stats.body',
      placement: 'bottom',
    },
    {
      target: TALENT_POOL_TOUR_TARGETS.filters,
      titleKey: 'walkthrough.talentPool.filters.title',
      bodyKey: 'walkthrough.talentPool.filters.body',
      placement: 'bottom',
    },
    {
      target: TALENT_POOL_TOUR_TARGETS.table,
      titleKey: 'walkthrough.talentPool.table.title',
      bodyKey: 'walkthrough.talentPool.table.body',
      placement: 'top',
    },
    {
      target: TALENT_POOL_TOUR_TARGETS.rowActionMatch,
      titleKey: 'walkthrough.talentPool.rowActionMatch.title',
      bodyKey: 'walkthrough.talentPool.rowActionMatch.body',
      placement: 'left',
    },
    {
      target: TALENT_POOL_TOUR_TARGETS.rowActionView,
      titleKey: 'walkthrough.talentPool.rowActionView.title',
      bodyKey: 'walkthrough.talentPool.rowActionView.body',
      placement: 'left',
    },
    {
      target: TALENT_POOL_TOUR_TARGETS.pagination,
      titleKey: 'walkthrough.talentPool.pagination.title',
      bodyKey: 'walkthrough.talentPool.pagination.body',
      placement: 'top',
    },
  ],
};
